/**
 * The API origin for this page, for both flows and the old-link lookup. On a tenant host —
 * `<service>.<tenant>.gomemo.io`, e.g. `selfie-dev.mx.gomemo.io` or `permanent-dev.il.gomemo.io` — it
 * is the build's API host with the tenant inserted after its first label (`https://api-dev.gomemo.io`
 * → `https://api-dev.mx.gomemo.io`), so one build serves every tenant and a dev build can only reach
 * dev APIs. Anything else (localhost, the shared names such as `live.gomemo.io`, the e2e run's
 * relative `/e2e-api`) keeps the build's value. (memo-selfie `src/utils/apiBaseUrl.js` and
 * memo-permanent `src/lib/apiBaseUrl.ts`, one copy here.)
 */
export function tenantApiBaseUrl(pageHostname: string, buildBaseUrl: string): string
export function tenantApiBaseUrl(pageHostname: string, buildBaseUrl: string | undefined): string | undefined
export function tenantApiBaseUrl(pageHostname: string, buildBaseUrl: string | undefined): string | undefined {
  const host = pageHostname.toLowerCase().replace(/\.$/, '')
  const tenant = /^[a-z0-9-]+\.([a-z0-9-]+)\.gomemo\.io$/.exec(host)?.[1]
  if (!tenant || !buildBaseUrl) return buildBaseUrl
  const api = /^(https?:\/\/[a-z0-9-]+)\.(gomemo\.io(?:[:/].*)?)$/i.exec(buildBaseUrl)
  if (!api) return buildBaseUrl
  return `${api[1]}.${tenant}.${api[2]}`
}
